

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
    },
    {
      key: 'museumname',
      dataIndex: 'museumname',
      title: '馆名',
      width: 100,
    },
    {
      key: 'project',
      dataIndex: 'project',
      title: '项目名称',
      width: 100,
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '等级',
    },
    {
      key: 'add',
      dataIndex: 'add',
      title: '拟加分',
    },
    {
      key: 'personcount',
      dataIndex: 'personcount',
      title: '加分专家人数',
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '推荐',

      width: 100,
      slot: 'operate1',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '详情',

      width: 100,
      slot: 'operate',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
